export const TOP_MENU = {
  LABELS: ['Film', 'Dokument', 'Památník obětí', 'O projektu'],
};

export const MEMORIAL = {
  TITLE: 'Památník obětí',
  INFO: 'Věnováno památce zesnulých horníků, jejich rodinám a\u00a0příbuzným.',
  ALT1: 'Logo památníku obětí',
  ALT2: 'Ilustrace nočního dolu',
};

export const INFO = {
  ALT1: 'Logo Dukla 61',
  ALT2: 'Ilustrace dolu',
};

export const SPECIAL_BULLETS = {
  START: 'Úvod',
  END: 'Epilog',
};

export const ALT = {
  BACK: 'Zpět',
};

export const COMPACT = {
  INFO: 'Pro lepší zážitek si zobrazte stránku na\u00a0počítači.',
  INFO_BIG:
    'Stránku lze přepnout na\u00a0interaktivní verzi otočením zařízení do\u00a0horizontální polohy.',
  ALT_TOP: 'Důl a logo',
  ALT_BTM: 'Důl - podzemí',
};



// WEBPACK FOOTER //
// ./src/texts.js